import {Component,type ReactNode} from 'react'

type Props={children:ReactNode;fallback?:ReactNode;label?:string}
export class AssetBoundary extends Component<Props,{failed:boolean}>{
 state={failed:false}
 static getDerivedStateFromError(){return{failed:true}}
 componentDidCatch(error:Error){
  console.warn(`[RiftFighters] ${this.props.label??'visual asset'} unavailable:`,error.message)
 }
 render(){return this.state.failed?(this.props.fallback??null):this.props.children}
}
